import { api } from "@api/api";
import { Category } from "@modules/categorys/types";
import { CategoryFormValues } from "@modules/categorys/validations";

export async function createCategoryService(data: CategoryFormValues): Promise<Category> {
  const { data: category } = await api.post<Category>("v1/category_admin/", data);

  return category;
}
